module.exports = __webpack_public_path__ + "static/img/tihuo2.8cb5d41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/tihuo2.jpg
// module id = wVd2
// module chunks = 33